import { Component, NgZone, inject, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UserLoginService } from '../../../service/user-login.service';
import { environment } from 'src/environments/environment';
import { LoginQueryParams } from '../../../types';

@Component({
  selector: 'app-auth-button',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent {
  // Inject the authentication service into your component through the constructor
  public auth = inject(AuthService);
  public router = inject(Router);
  private route = inject(ActivatedRoute);
  public userService = inject(UserLoginService);
  private ngZone = inject(NgZone);
  public email = signal<string>('');
  public loading = signal<boolean>(false);

  public checkUser() {
    const email = this.email()?.trim();
    if (!email || this.loading()) return;

    this.loading.set(true);

    this.userService.getUserConnection(email).subscribe({
      next: (connection) => {
        this.handleAuthFlow(connection, email);
      },
      error: (err) => {
        console.error(err);
        this.loading.set(false);
      },
    });
  }

  private handleAuthFlow(connection: string, email: string) {
    const returnTo = sessionStorage.getItem('post_login_redirect');

    let returnUrl = this.route.snapshot.queryParams[LoginQueryParams.RETURN_URL] || '/';
    returnUrl = returnTo ? returnTo : returnUrl;
    sessionStorage.removeItem('post_login_redirect');

    const authorizationParams: any = {
      login_hint: email,
    };

    if (connection === 'email') {
      // this.userService.passwordLessStart(this.email()).subscribe(() => {});
      window.location.href =
        `https://${environment.auth0Domain}/passwordless/start` +
        `?client_id=${environment.auth0ClientId}` +
        `&connection=email&send=link&email=${encodeURIComponent(email)}`;
    }

    authorizationParams.connection = connection;
    sessionStorage.setItem('post_login_redirect_app_state_expired', returnUrl);

    this.auth
      .loginWithRedirect({
        authorizationParams,
        appState: {
          target: returnUrl,
        },
      })
      .subscribe({
        error: () => this.loading.set(false),
      });
  }
}
